import React, { useState } from "react";

const VerticalRadioButtonList = ({
	name,
	dataItems = [
		{ id: 1, text: "Option 1", checked: false },
		{ id: 2, text: "Option 2", checked: false },
		{ id: 3, text: "Option 3", checked: false },
	],
	handleChange,
	initialID,
	className,
}) => {
	const [selectedItemId, setSelectedItemId] = useState(initialID);
	const handleRadioChange = (itemId) => {
		setSelectedItemId(itemId);
		handleChange(itemId);
	};

	// React.useEffect(() => {
	//   setSelectedItemId(null); // Clear the selected item when the dataItems prop changes.
	// }, [dataItems]);

	return (
		<div className={`space-y-2 grid grid-cols-1 items-end gap-2 ${className}`}>
			{dataItems.map((item) => (
				<label key={item.id} className=" items-start space-x-2 p-1 flex">
					<input
						name={
							name === "" || name === undefined || name === null || name === " "
								? "(Name is not defined)"
								: name
						}
						type="radio"
						className="form-radio h-5 w-5 text-blue-600 my-auto"
						value={item.id}
						checked={selectedItemId ? selectedItemId === item.id : item.checked}
						onChange={() => handleRadioChange(item.id)}
					/>
					<span className="my-auto">{item.text}</span>
				</label>
			))}
		</div>
	);
};

export default VerticalRadioButtonList;
